// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top-bar[data-v-15dbbd29]{border-bottom:1px solid var(--v-form-border-base);z-index:11}.v-application .pr-4[data-v-15dbbd29]{padding-right:0px !important}.lower-top-bar[data-v-15dbbd29]{position:fixed;top:50px;width:100%;z-index:10}.shrinkLogo[data-v-15dbbd29]{width:100px}\n", ""]);
// Exports
module.exports = exports;
